import React from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    Box,
    Typography
} from "@mui/material";
import {observer} from "mobx-react";
import {AvantColors} from "../../styles/AvantColors";
import {theme} from "../../styles/MuiThemes";
import {LoginProductContentAreaData, SelectOption} from "../../types/types";
import Button from "../Button/Button";
import {LoginFormStore} from "./Login";

interface LoginProductSelectionModalProps {
    store: LoginFormStore;
    handleLoginProduct: (loginProduct: LoginProductContentAreaData) => void;
}

@observer
export class LoginProductSelectionModal extends React.Component<LoginProductSelectionModalProps> {
    closeLoginModal = () => {
        const loginId = this.props.store.loginId;
        const loginIdToData: Map<string, LoginProductContentAreaData> = this.props.store.loginIdToData;
        if (loginId != null) {
            this.props.store.showProductModal = false;
            if (!loginIdToData.has(loginId)) {
                throw Error(`this.state.loginIdToData is missing loginId ${loginId}`);
            }
            const loginProduct: LoginProductContentAreaData = loginIdToData.get(loginId)!;
            this.props.handleLoginProduct(loginProduct);
        }
    };

    handleChange = (event: SelectChangeEvent) => {
        this.props.store.loginId = event.target.value;
    };

    render() {
        return (
            <Dialog
                open={this.props.store.showProductModal}
                onClose={this.closeLoginModal}
                data-tst-id="product-modal"
                PaperProps={{ style: { width: 360, padding: theme.spacing(2) } }}
            >
                <DialogTitle sx={{textAlign: "center", py: 1.5, px: 2}}>
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: 900, color: AvantColors.REPORT_FONT_COLOR_BLACK }}
                    >
                        Choose a product
                    </Typography>
                </DialogTitle>

                <Divider sx={{ width: "100%" }} />

                <DialogContent sx={{ textAlign: "center" }}>
                    <FormControl fullWidth sx={{ mb: 2 }}>

                        <Select
                            labelId="product-select-label"
                            value={this.props.store.loginId}
                            onChange={this.handleChange}
                            displayEmpty
                            inputProps={{
                                tabIndex: 0,
                                "data-tst-id": "product-dropdown"
                            }}
                            renderValue={(selected) => {
                                if (!selected) {
                                    return <span style={{ color: "#aaa" }}>Select a product</span>;
                                }
                                const selectedOption = this.props.store.loginOptions.find(
                                    (opt) => opt.value === selected
                                );
                                return selectedOption ? selectedOption.label : "";
                            }}
                        >
                            <MenuItem value="" disabled>
                                Select a product
                            </MenuItem>
                            {this.props.store.loginOptions.map((product: SelectOption, index) => (
                                <MenuItem
                                    key={product.value}
                                    value={product.value}
                                    data-tst-id={product.testId}
                                    tabIndex={index + 1}
                                >
                                    {product.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Box>
                        <Button
                            className="login__login-container__modal-button avant-button--primary"
                            onClick={this.closeLoginModal}
                            testId={"ok-button"}
                        >
                            OK
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        );
    }
}
